/* ── Mobile Responsive CSS ── */
export const mobileCSS = `
/* ══════════════════════════════════════════════════════
   BLITZ CRM v30.06 — Full Mobile Responsive System
   Covers: header, nav, tables, modals, forms, all pages
══════════════════════════════════════════════════════ */

/* ── Base mobile reset ── */
* { box-sizing: border-box !important; }
html, body { overflow-x: hidden !important; max-width: 100vw !important; }
/* FIX 1: Prevent number inputs from changing value on scroll (mobile) */
input[type=number] { -moz-appearance: textfield !important; }
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button { -webkit-appearance: none !important; margin: 0 !important; }

/* ── Table scroll wrapper — all tables scroll horizontally on mobile ── */
.blitz-table-wrap, .blitz-table-responsive {
  overflow-x: auto !important;
  -webkit-overflow-scrolling: touch !important;
  max-width: 100% !important;
}

@media (min-width: 769px) {
  .blitz-table-responsive .mobile-cards { display: none !important; }
}

@media (max-width: 768px) {
  /* ── Header ── */
  .blitz-header {
    padding: 10px 14px !important;
    min-height: 56px !important;
  }
  .blitz-header .nav-links { display: none !important; }
  .blitz-header .desktop-actions { display: none !important; }
  .blitz-header .mobile-menu-btn { display: flex !important; }

  /* ── Main content area ── */
  .blitz-main {
    padding: 14px 12px !important;
    max-width: 100vw !important;
    overflow-x: hidden !important;
  }
  .blitz-main h1 { font-size: 20px !important; }
  .blitz-main h2 { font-size: 17px !important; }

  /* ── All flex rows → column on mobile ── */
  .blitz-toolbar {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 8px !important;
  }
  .blitz-toolbar input,
  .blitz-toolbar select {
    width: 100% !important;
    min-width: unset !important;
  }

  /* ── Summary/KPI grids ── */
  .blitz-summary { grid-template-columns: 1fr 1fr !important; gap: 10px !important; }

  /* ── Modals ── */
  .blitz-modal-content {
    width: 96vw !important;
    max-width: 96vw !important;
    margin: 8px auto !important;
    padding: 18px 14px !important;
    border-radius: 14px !important;
    max-height: 92vh !important;
    overflow-y: auto !important;
  }
  .blitz-modal-content .grid-2col { grid-template-columns: 1fr !important; }
  .blitz-form-grid { grid-template-columns: 1fr !important; }

  /* ── Buttons — minimum tap target 44px ── */
  button { min-height: 40px !important; }

  /* ── Tables — scroll horizontally, don't overflow ── */
  .blitz-table-responsive table { display: none !important; }
  .blitz-table-responsive .mobile-cards { display: flex !important; }

  /* All tables that are NOT in blitz-table-responsive: wrap in scroll ── */
  table {
    min-width: unset !important;
    font-size: 12px !important;
  }
  table th, table td {
    padding: 7px 8px !important;
    font-size: 11px !important;
    white-space: normal !important;
    word-break: break-word !important;
  }

  /* ── Page-level containers: remove fixed padding ── */
  [style*="padding: 28px 32px"],
  [style*="padding: 24px 28px"],
  [style*="padding: 20px 24px"] {
    padding: 14px 12px !important;
  }
  [style*="padding: 20px 32px"] { padding: 14px 12px !important; }

  /* ── Flex rows with gap → column ── */
  [style*="display: flex"][style*="gap: 24"],
  [style*="display: flex"][style*="gap: 20"],
  [style*="display: flex"][style*="gap: 32"] {
    flex-direction: column !important;
    gap: 12px !important;
  }

  /* ── Grid layouts → single column ── */
  [style*="grid-template-columns: 1fr 1fr"],
  [style*="gridTemplateColumns: '1fr 1fr'"],
  [style*="grid-template-columns: repeat(2"],
  [style*="grid-template-columns: repeat(3"],
  [style*="grid-template-columns: repeat(4"] {
    grid-template-columns: 1fr !important;
  }

  /* ── Fixed/min widths that cause overflow ── */
  [style*="minWidth: 600"],
  [style*="minWidth: 500"],
  [style*="minWidth: 400"],
  [style*="minWidth: 300"],
  [style*="min-width: 600px"],
  [style*="min-width: 500px"],
  [style*="min-width: 400px"] {
    min-width: unset !important;
    width: 100% !important;
  }

  /* ── Settings page ── */
  .blitz-settings-grid { grid-template-columns: 1fr !important; }

  /* ── User management table ── */
  .blitz-user-table-wrap { overflow-x: auto !important; }

  /* ── Dashboard FTD section ── */
  .blitz-ftd-rankings {
    flex-direction: column !important;
    gap: 12px !important;
  }

  /* ── PNL Daily — two side-by-side tables → stacked ── */
  .blitz-pnl-wrap {
    flex-direction: column !important;
    gap: 16px !important;
  }
  .blitz-pnl-wrap > div { width: 100% !important; min-width: unset !important; }

  /* ── CRG Deals table ── */
  .blitz-crg-table { overflow-x: auto !important; }

  /* ── Page title row (title + buttons) ── */
  .blitz-page-title-row {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 10px !important;
  }

  /* ── Date range pickers ── */
  .blitz-date-row {
    flex-direction: column !important;
    gap: 8px !important;
  }
  .blitz-date-row input { width: 100% !important; }

  /* ── Back button bar ── */
  [style*="Back to Dashboard"] { font-size: 12px !important; padding: 6px 10px !important; }

  /* ── Version badge + breadcrumb in header ── */
  [style*="v13"], [style*="v12"] { font-size: 10px !important; padding: 2px 7px !important; }

  /* ── Overflow containers ── */
  .blitz-overflow-x { overflow-x: auto !important; -webkit-overflow-scrolling: touch !important; }
  /* FIX 12: Right-shadow scroll hint — shows users the table scrolls horizontally */
  .blitz-table-wrap, .blitz-table-responsive, .blitz-overflow-x {
    background:
      linear-gradient(to right, white 30%, rgba(255,255,255,0)) left,
      linear-gradient(to left, white 30%, rgba(255,255,255,0)) right,
      radial-gradient(farthest-side at 0 50%, rgba(0,0,0,0.08), transparent) left,
      radial-gradient(farthest-side at 100% 50%, rgba(0,0,0,0.08), transparent) right;
    background-repeat: no-repeat;
    background-size: 40px 100%, 40px 100%, 12px 100%, 12px 100%;
    background-attachment: local, local, scroll, scroll;
  }
}

@media (max-width: 480px) {
  /* ── Extra small phones ── */
  .blitz-summary { grid-template-columns: 1fr !important; }
  .blitz-main { padding: 10px 8px !important; }
  /* FIX 13: position:sticky broken in overflow-x:auto on iOS Safari — override to overflow:clip */
  .blitz-table-wrap, .blitz-crg-table { overflow-x: auto !important; overflow-y: clip !important; }
  /* FIX 11: :active states as hover replacement for touch devices */
  button:active { opacity: 0.75 !important; transform: scale(0.97) !important; }
  tr:active { background: rgba(14,165,233,0.06) !important; }
/* FIX 9: Minimum readable font sizes — 8/9/10px is unreadable on small phones */
  span[style*="font-size: 9"], span[style*="fontSize: 9"],
  span[style*="font-size: 10"], span[style*="fontSize: 10"] {
    font-size: 11px !important;
  }
  div[style*="font-size: 9"], div[style*="font-size: 10"] {
    font-size: 11px !important;
  }
  table th, table td { padding: 6px 6px !important; font-size: 10px !important; }
  .blitz-modal-content { padding: 14px 10px !important; }
}
`;
